import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import MuiTabs from '@material-ui/core/Tabs';

const StyledTabs = styled(MuiTabs)`
  &&& {
    position: relative;
    background: #ffffff;
    flex: 1;
  }
`;

const tabsStyles = makeStyles({
  indicator: {
    backgroundColor: '#00b33b',
    width: '24px',
    height: '4px',
    borderRadius: '2px',
  },
});

const Tabs = ({ current, renderTab }) => {
  const tabsClasses = tabsStyles();

  return (
    <StyledTabs
      classes={{ indicator: tabsClasses.indicator }}
      value={current}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      key="ItineraryRouteTabs"
      aria-label="itineray-day-tabs"
    >
      { renderTab() }
    </StyledTabs>
  );
};

Tabs.propTypes = {
  renderTab: PropTypes.func,
  current: PropTypes.number,
};

Tabs.defaultProps = {
  current: 0,
  renderTab: () => {},
};

export default Tabs;
